module.exports = __webpack_public_path__ + "static/media/retail-industry.0780bf4e.svg";